import { CourseDef } from '../../../../types';
import L2084304 from './2084304';
import L2084305 from './2084305';
import L2084306 from './2084306';
import L2084307 from './2084307';
// import L5234479 from './5234479';
import L5234480 from './5234480';

export const tradeNaPratica: CourseDef = {
  courseTitle: 'TRADE NA PRÁTICA',
  lessons: [L2084304, L2084305, L2084306, L2084307, 
    // L5234479, 
    L5234480],
};

